import { connect } from 'react-redux';
import DashboardWalletSocietyHistory from './DashboardWalletSocietyHistory';
const mapStateToProps = (state) => ({
    iss: state.roles.iss,
});
export default connect(mapStateToProps)(DashboardWalletSocietyHistory);
